import { z } from "zod";
import { SUPPORTED_CARRIER_IDS } from "helpers/carriers";
import { currentYear } from "./currentYear";
import { parseCurrencyToNumber } from "./parseCurrencyToNumber";

const Step7TrailerBase = z.object({
  id: z.string().optional(),
  type: z.string().optional().default("trailer"),

  year: z
    .union([z.string(), z.number()])
    .transform((v) => Number(v))
    .refine((v) => Number.isInteger(v), "Year is required")
    .refine((v) => v >= 1900, "Year must be valid")
    .refine((v) => v <= currentYear + 1, "Year cannot be in the future"),

  make: z.string().min(1, "Make is required"),
  model: z.string().min(1, "Model is required"),

  vin: z
    .string()
    .min(1, "VIN is required")
    .regex(
      /^[A-Za-z0-9]{17}$/,
      "VIN must be exactly 17 characters long and contain only letters and numbers"
    ),

  value: z
    .any()
    .transform(parseCurrencyToNumber)
    .refine((n) => Number.isFinite(n) && n > 0, "Value is required"),

  bodyType: z.string().min(1, "Body Type is required"),

  deductibleType: z.string().optional(),
  deductible: z.string().optional(),
});

export const Step7TrailerSchema = Step7TrailerBase.superRefine(() => {});

export const Step7Schema = z
  .object({
    trailers: z.array(Step7TrailerSchema),
    carrier: z.array(z.enum(SUPPORTED_CARRIER_IDS)).default([]),
    nbrOfTrailers: z.number().optional().default(0),
    valueOfTrailers: z.number().optional().default(0),

    // dialog scratchpad
    newTrailer: Step7TrailerBase.partial().optional(),
  })
  .superRefine((data, ctx) => {
    const hasCoverWhale = data.carrier.includes("Cover Whale");
    const hasNirvana = data.carrier.includes("Nirvana");
    const hasProgressive = data.carrier.includes("Progressive");
    const hasCwOrNirvana = hasCoverWhale || hasNirvana;

    data.trailers.forEach((t, idx) => {
      const age = currentYear - Number(t.year);
      const overLimit = Number.isFinite(age) && age > 23;

      if (hasCwOrNirvana && !hasProgressive && overLimit) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["trailers", idx, "year"],
          message: "Trailers above 23 years of age are not eligible",
        });
      }
    });
  });
